module.exports = __webpack_public_path__ + "media/images/calculos_laborales_ico-d2edf744.png";